import React, { useCallback, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useSessaoAtual } from "../../../services/providers/sessao-atual-provider/sessao-atual-provider";
import { useHistory } from "react-router";
import { useFormik } from "formik";
import './autoComRepresentante.css';
import { CircularLoading } from "../../components/utils/circular-loading";
import { BaixasStorageKeys, useBaixasStorage } from "../../../services/use-cases/baixas-storage";
import { Helmet } from "react-helmet";
import Logo from '../../components/public/ImagemRepresentanteLogin.png';
import Ellipse1 from '../../components/public/login/ellipse13534366-h1ms.svg';
import Ellipse2 from '../../components/public/login/ellipse13534367-x809.svg'

export const LoginRepresentantePage = () => {
    const { LoginRepresentante, carregando } = useSessaoAtual();
    const { getRegister } = useBaixasStorage()
    const history = useHistory();
    const representante = getRegister(BaixasStorageKeys.dataRepresentante)

    const formik = useFormik({
        initialValues: {
            senha: ''
        },
        onSubmit: values => {
            EfetuarLogin(values.senha)
        }
    })

    const EfetuarLogin = useCallback(async (senha: string) => {
        try {
            await LoginRepresentante(senha)
            history.push('/representante/clientes')
        } catch (e: any) {
            toast.error(e.message);
        }
    }, [LoginRepresentante, history])

    useEffect(() => {
        if (representante.id) {
            history.push('/representante/clientes')
        }
    }, [getRegister, history, representante?.id])
    return (
        <div className="loginRepresentantePage">
        <Helmet>
            <title>Login Representante - Saurus AutoCom</title>
        </Helmet>
            <div className="p-d-v1430-container">
                <div className="p-d-v1430-p-d-v1430">
                    <div className="p-d-v1430-group11911453">
                        <img alt="Ellipse11455" src={Ellipse1} className="p-d-v1430-svg09" />
                        <img alt="Ellipse11454" src={Ellipse2} className="p-d-v1430-svg10" />
                    </div>
                </div>
            </div>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <div className="container container-login-representante">
                <div className="content-login-representante pt-5">
                    <img alt="Ellipse11454" style={{ width: 200 }} src={Logo} />
                </div>
                <div className="d-flex justify-content-center" style={{height: '100%'}}>
                    <div className="content">
                        <form onSubmit={formik.handleSubmit} style={{height: '100%'}}>
                            <div className="content-acessar">
                                <div className="focar-tela-inteira">
                                    <div>
                                        <div className="mb-3">
                                            <span className="p-d-v1430-text03">Login</span>
                                        </div>
                                        <div className="mb-4">
                                            <span>Para continuar digite o seu código de acesso abaixo.</span>
                                        </div>
                                        <div className="mb-2">
                                            <div className="mb-2">
                                                <span className="form-label">Senha</span>
                                            </div>
                                            <input type="password" className="form-control"
                                                {...formik.getFieldProps('senha')} title="Senha" name="senha" />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-grid gap-2 mt-4 mb-3 container-btn-acessar">
                                    <button className="btn btn-acessar" type="submit">Acessar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}